import { defineStore } from "pinia";
import { ref } from "vue";

export interface SystemStatusItem {
  id: number;
  tipoEntidad: string;
  codigoEntidad: string;
  comportamiento: string;
  activo: number;
  descripcion: string;
  fechaCreacion: string;
  fechaModificacion: string;
}

export interface UpdateStatusPayload {
  ids: number[];
  activo: number;
}

export const useSystemStatusStore = defineStore(
  "systemStatus",
  () => {
    const statusItems = ref<SystemStatusItem[]>([]);
    const isLoading = ref<boolean>(false);
    const isUpdating = ref<boolean>(false);

    const setStatusItems = (items: SystemStatusItem[]) => {
      statusItems.value = items;
    };

    const setIsLoading = (value: boolean) => {
      isLoading.value = value;
    };

    const setIsUpdating = (value: boolean) => {
      isUpdating.value = value;
    };

    return {
      statusItems,
      isLoading,
      isUpdating,
      setStatusItems,
      setIsLoading,
      setIsUpdating,
    };
  },
  {
    persist: true,
  },
);
